export const stringifyClone = (value: any) => JSON.parse(JSON.stringify(value))